import React, { useEffect, useState } from 'react';
import Select, { Props as SelectProps } from 'react-select';
import styled from 'styled-components';

/**
 * ReactSelect component
 *
 * This wrapper is needed to prevent the Select component
 * from being rendered before the component is mounted. This
 * is done because of this react-select issue:
 * https://github.com/JedWatson/react-select/issues/5859
 *
 * @param props - SelectProps
 * @returns ReactSelect component
 */
function ReactSelect(props: SelectProps<any>) {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return <SelectPlaceholder className={props.className} />;
  }

  return <Select {...props} />;
}

export default ReactSelect;

const SelectPlaceholder = styled.div`
  background-color: transparent;
  height: 40px;
`;
